module.exports = __webpack_public_path__ + "static/media/ic-history-black-24-px-white.b0c4217c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-history-black-24-px-white.svg
// module id = 1370
// module chunks = 0